import { orderBy } from 'lodash-es';
export function filterClients(param) {
    let { clients, searchTerm, statusFilter, typeFilter } = param;
    const trimmedSearch = searchTerm.trim().toLowerCase();
    return clients.filter((client)=>{
        const passesSearch = !trimmedSearch || client.name.toLowerCase().includes(trimmedSearch) || client.owners.some((owner)=>owner.name.toLowerCase().includes(trimmedSearch) || owner.email.toLowerCase().includes(trimmedSearch));
        const passesStatus = statusFilter.length === 0 || statusFilter.includes(client.status);
        const passesType = typeFilter.length === 0 || typeFilter.includes(client.type);
        return passesSearch && passesStatus && passesType;
    });
}
export function sortClients(param) {
    let { clients, sortKey, sortDirection } = param;
    var _sortPropertiesByKey_sortKey;
    const sortPropertiesByKey = {
        clientName: [
            (c)=>c.name.toLowerCase()
        ],
        status: [
            (c)=>c.status,
            (c)=>c.name.toLowerCase()
        ],
        type: [
            (c)=>c.type,
            (c)=>c.name.toLowerCase()
        ],
        owner: [
            (c)=>{
                var _ref;
                var _c_owners_;
                return ((_ref = (_c_owners_ = c.owners[0]) === null || _c_owners_ === void 0 ? void 0 : _c_owners_.name) !== null && _ref !== void 0 ? _ref : '').toLowerCase();
            },
            (c)=>c.name.toLowerCase()
        ],
        lastInvoice: [
            (c)=>{
                var _c_lastInvoiceDate;
                return (_c_lastInvoiceDate = c.lastInvoiceDate) !== null && _c_lastInvoiceDate !== void 0 ? _c_lastInvoiceDate : '';
            },
            (c)=>c.name.toLowerCase()
        ],
        nextInvoice: [
            (c)=>{
                var _c_nextInvoiceDate;
                return (_c_nextInvoiceDate = c.nextInvoiceDate) !== null && _c_nextInvoiceDate !== void 0 ? _c_nextInvoiceDate : '';
            },
            (c)=>c.name.toLowerCase()
        ]
    };
    const sortProperties = (_sortPropertiesByKey_sortKey = sortPropertiesByKey[sortKey]) !== null && _sortPropertiesByKey_sortKey !== void 0 ? _sortPropertiesByKey_sortKey : sortPropertiesByKey.clientName;
    const orders = sortProperties.map(()=>sortDirection);
    return orderBy(clients, sortProperties, orders);
}
